import { useState, useParams, Link, BiCategory, FaRegUserCircle, ToastContainer, MdErrorOutline, FaArrowAltCircleRight, overlayStyle, loaderStyle } from '../../common/common';

import useNavigation from '../../common/useNavigation';
import { useErrorContext } from '../../context/ErrorContext';
import MidSettings from '../../middleware/Settings/MidSettings';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';

const Settings = () => {
    const { type } = useParams();
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const { error } = useErrorContext();
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { values, users,userPlan,Remainuser,subUser, handleChange, handleFileChange, handleSubmit, fileInputRef, isLoading } = MidSettings(type);
    const { navigateGeneralSetting } = useNavigation();
    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var usertypeArray = usertype.split(',').map(Number);
        var hasOne = usertypeArray.includes(1);
        var hasTwo = usertypeArray.includes(2);
        var hasOneAndTwo = [1, 2].every(num => usertypeArray.includes(num));
        var username = users[0]['FullName'];
        var CompanyName = users[0]['CompanyName'];
        var userAddress1 = users[0]['Address1'];
        var userAddress2 = users[0]['Address2'];
        var Mobile = users[0]['Mobile'];
        var RegistrationDate = users[0]['RegistrationDate'];
        var EmailAddress = users[0]['EmailAddress'];
    }
    if(Array.isArray(userPlan) && userPlan.length > 0){
        var planID = userPlan[0]['plan_id'];
    }
    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID}/>
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="w-full ">
                    <div className="col-start-1 col-end-13">
                        <div className=" p-2 text-xl text-[#1e3a8a]">
                            <div className='px-3'>
                                <h1 className=' text-lg text-theme-color-text font-bold'> Product Categories</h1>
                                <p className=' text-gray-600 text-[16px] '>A product category is a group of similar type of products. Ex. Menswear,Womenswear,Childrenswear</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fixed border-0 flex-row rounded-xl m-3 p-4 ">
                    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-5 lg:gap-7.5">


                        <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <Link className="text-base font-medium leading-none text-gray-900 hover:text-primary-active"  to={`${(type === 'seller') ? '/seller/profile/' : '/buyer/profile/'}`}>
                                        Personal Info
                                    </Link>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        Update your personal details and explore opportunities for collaboration, guest posts, and promotions.
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                    Billing &amp; Payments
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        We're open to partnerships, guest posts, promo bannersand more.
                                    </span>
                                </div>
                            </div>
                        </div> */}

                        {(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <Link to={`/seller/EditProductAttributes/`} className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" >
                                        Product Attributes
                                    </Link>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        Customize product details such as size, color, and specifications.
                                    </span>
                                </div>
                            </div>
                        </div> : null}
                        {/* <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                    Excel Import & Print Order
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        We're open to partnerships, guest posts, promo bannersand more.
                                    </span>
                                </div>
                            </div>
                        </div> */}
                        {(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <Link to={`/seller/Badges/`} className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" >
                                        Badges
                                    </Link>

                                    <span className="text-2sm text-gray-700 leading-5">
                                        Create and assign visual tags to highlight product features, deals, or special statuses.
                                    </span>
                                </div>
                            </div>
                        </div> : null } 
                        {/* <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                    Stock Status
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        We're open to partnerships, guest posts, promo bannersand more.
                                    </span>
                                </div>
                            </div>
                        </div> */}

{(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">

                                    <Link to={`/seller/Warehouse/`} className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" >
                                        Warehouses
                                    </Link>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        Manage inventory locations, stock levels, and fulfillment centers for efficient order processing.
                                    </span>
                                </div>
                            </div>
                        </div> : null }

                        {/* <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                    Territories
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        We're open to partnerships, guest posts, promo bannersand more.
                                    </span>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                    Tax Tiers
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        We're open to partnerships, guest posts, promo bannersand more.
                                    </span>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                    Offer Settings
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        We're open to partnerships, guest posts, promo bannersand more.
                                    </span>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                    Stock Information Settings
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        We're open to partnerships, guest posts, promo bannersand more.
                                    </span>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                    Custom Order Fields 
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        We're open to partnerships, guest posts, promo bannersand more.
                                    </span>
                                </div>
                            </div>
                        </div> */}
                        {(hasTwo && type === 'seller') || (hasOneAndTwo && type === 'seller') ? <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                        API Access Settings
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        Manage your API keys and control third-party access to your platform’s data and functionality.
                                    </span>
                                </div>
                            </div>
                        </div>:null } 
                         <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                        Notifications
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        Customize how and when you receive alerts, updates, and system messages.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-row [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4]  p-3  lg:p-7.5 lg:pt-7">
                            <div className="flex flex-row gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />
                                </div>
                                <div className="flex flex-col gap-3 mt-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                        Theme
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        Personalize the look and feel of your interface with layout and dark theme options.
                                    </span>
                                </div>
                            </div>
                        </div>




                        {/* <div className="flex flex-col [box-shadow:0px_3px_4px_0px_rgba(0,0,0,.03)] bg-[white] rounded-[.75rem] border-[1px] border-[solid] border-[#f1f1f4] p-5 lg:p-7.5 lg:pt-7">
                            <div className="flex flex-col gap-4">
                                <div className="flex items-center justify-between gap-2">
                                    <FaRegUserCircle />

                                </div>
                                <div className="flex flex-col gap-3">
                                    <a className="text-base font-medium leading-none text-gray-900 hover:text-primary-active" href="#">
                                        Devices
                                    </a>
                                    <span className="text-2sm text-gray-700 leading-5">
                                        Stay ahead with the latest devices and innovations news
                                    </span>
                                </div>
                            </div>
                        </div> */}


                    </div>

                </div>
            </div>
        </div>

    )
}

export default Settings